'use strict';
var focusHelper = require('../components/focus');
var picture_lazy_load = require('../modules/picture-lazy-load');
picture_lazy_load.init();

/**
 * Retrieves the relevant pid value
 * @param {jquery} $el - DOM container for a given add to cart button
 * @return {string} - value to be used when adding product to cart
 */
function getPidValue($el) {
    var pid;

    if ($('#quickViewModal').hasClass('show') && !$('.product-set').length) {
        pid = $($el).closest('.modal-content').find('.product-quickview').data('pid');
    } else if ($('.product-set-detail').length || $('.product-set').length) {
        pid = $($el).closest('.product-detail').find('.product-id').text();
    } else {
        pid = $('.product-detail:not(".bundle-item")').data('pid');
    }

    return pid;
}

/**
 * Retrieve contextual quantity selector
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {jquery} - quantity selector DOM container
 */
function getQuantitySelector($el) {
    var quantitySelected;
    if ($el && $('.set-items').length) {
        quantitySelected = $($el).closest('.product-detail').find('.quantity-select');
    } else if ($el && $('.product-bundle').length) {
        var quantitySelectedModal = $($el).closest('.modal-footer').find('.quantity-select');
        var quantitySelectedPDP = $($el).closest('.bundle-footer').find('.quantity-select');
        if (quantitySelectedModal.val() === undefined) {
            quantitySelected = quantitySelectedPDP;
        } else {
            quantitySelected = quantitySelectedModal;
        }
    } else {
        quantitySelected = $('.quantity-select');
    }
    return quantitySelected;
}

/**
 * Retrieves the value associated with the Quantity pull-down menu
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {string} - value found in the quantity input
 */
function getQuantitySelected($el) {
    return getQuantitySelector($el).val();
}

/**
 * Process the attribute values for an attribute that has image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 * @param {Object} msgs - object containing resource messages
 */
function processSwatchValues(attr, $productContainer, msgs) {
    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer.find('[data-attr="' + attr.id + '"] [data-attr-value="' +
            attrValue.value + '"]');
        var $swatchButton = $attrValue.parent();

        if (attrValue.selected) {
            $attrValue.addClass('selected');
            $attrValue.siblings('.selected-assistive-text').text(msgs.assistiveSelectedText);
        } else {
            $attrValue.removeClass('selected');
            $attrValue.siblings('.selected-assistive-text').empty();
        }

        if (attrValue.url) {
            $swatchButton.attr('data-url', attrValue.url);
        } else {
            $swatchButton.removeAttr('data-url');
        }

        /*Disable if not selectable
        $attrValue.removeClass('selectable unselectable');

        $attrValue.addClass(attrValue.selectable ? 'selectable' : 'unselectable');
        */
    });
}

/**
 * Process attribute values associated with an attribute that does not have image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function processNonSwatchValues(attr, $productContainer) {
    var $attr = '[data-attr="' + attr.id + '"]';
    var $defaultOption = $productContainer.find($attr + ' .select-' + attr.id + ' option:first');
    $defaultOption.attr('value', attr.resetUrl);

    attr.values.forEach(function (attrValue) {
        if(attrValue.selected && attrValue.resetToDefault) {
            $defaultOption.prop('selected', true);
            attributeSelect(attr.resetUrl, $productContainer);
            return false;
        }
        var $attrValue = $productContainer
            .find($attr + ' [data-attr-value="' + attrValue.value + '"]');
        $attrValue.attr('value', attrValue.url)
            .removeAttr('disabled');

        if (!attrValue.available) {
            $attrValue.attr('disabled', true);
        } else if (!attrValue.selectable) {
            $attrValue.attr('data-content', attrValue.displayValue + '<span class="custom-select-text sold-out">' + attrValue.outOfStockMessage + '<span>');
        }

    });
    
    $('.selectpicker').selectpicker('refresh');
}

/**
 * Routes the handling of attribute processing depending on whether the attribute has image
 *     swatches or not
 *
 * @param {Object} attrs - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {Object} msgs - object containing resource messages
 */
function updateAttrs(attrs, $productContainer, msgs) {
    // Currently, the only attribute type that has image swatches is Color.
    var attrsWithSwatches = ['color'];

    attrs.forEach(function (attr) {
        if (attrsWithSwatches.indexOf(attr.id) > -1) {
            processSwatchValues(attr, $productContainer, msgs);
        } else {
            processNonSwatchValues(attr, $productContainer);
        }
    });
}

/**
 * Updates the availability status in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateAvailability(response, $productContainer) {
    var availabilityValue = '';

    $($productContainer).trigger('product:updateAvailability', {
        product: response.product,
        $productContainer: $productContainer,
        message: availabilityValue,
        resources: response.resources
    });
}

/**
 * Generates html for product attributes section
 *
 * @param {array} attributes - list of attributes
 * @return {string} - Compiled HTML
 */
function getAttributesHtml(attributes) {
    if (!attributes) {
        return '';
    }

    var html = '';

    attributes.forEach(function (attributeGroup) {
        if (attributeGroup.ID === 'mainAttributes') {
            attributeGroup.attributes.forEach(function (attribute) {
                html += '<div class="attribute-values">' + attribute.label + ': '
                    + attribute.value + '</div>';
            });
        }
    });

    return html;
}

/**
 * @typedef UpdatedOptionValue
 * @type Object
 * @property {string} id - Option value ID for look up
 * @property {string} url - Updated option value selection URL
 */

/**
 * @typedef OptionSelectionResponse
 * @type Object
 * @property {string} priceHtml - Updated price HTML code
 * @property {Object} options - Updated Options
 * @property {string} options.id - Option ID
 * @property {UpdatedOptionValue[]} options.values - Option values
 */

/**
 * Updates DOM using post-option selection Ajax response
 *
 * @param {OptionSelectionResponse} optionsHtml - Ajax response optionsHtml from selecting a product option
 * @param {jQuery} $productContainer - DOM element for current product
 */
function updateOptions(optionsHtml, $productContainer) {
	// Update options
    $productContainer.find('.product-options').empty().html(optionsHtml);
}

function updateSlider(product, $productContainer) {
    var thumbnailContainer = $productContainer.find('#thumbnail-slider > .splide__track > .splide__list');
    var galleryContainer = $productContainer.find('#main-slider > .splide__track > .splide__list');
    thumbnailContainer.empty();
    galleryContainer.empty();
    var maxNumberOfImages = product.images.large.length <= 18 ? product.images.large.length : 18;
    for (var i = 0; i < maxNumberOfImages; i++) {
        thumbnailContainer.append('<li class="splide__slide">' + product.images.large[i].templateResizedDevices + '</li>');
        galleryContainer.append('<li class="splide__slide">' + product.images.large[i].templateResizedDevices + '</li>');
    }
    if(product.hasVideo) {
        thumbnailContainer.append('<li class="splide__slide clickvideo"><img src="' + product.video.videoIcon + '" alt="" /></li>');
        galleryContainer.append('<li class="splide__slide" data-splide-youtube="' + product.video.videoURL + '"><img src="' + product.video.videoBackground + '" alt="" /></li>');
        $('.splide-link').addClass('hasvideo');
        $('.linkvideo').show();
    } else {
        $('.splide-link').removeClass('hasvideo');
        $('.linkvideo').hide();
    }
    if(product.hasImage360) {
        thumbnailContainer.append('<li class="splide__slide click360"><img src="' + product.image360.image360Icon + '" alt="" /></li>');
        galleryContainer.append('<li class="splide__slide image360"><iframe class="cc-video" loading="lazy" src="' + product.image360.image360URL + '"></iframe></li>');
        $('.splide-link').addClass('has360');
        $('.link360').show();
    } else {
        $('.splide-link').removeClass('has360');
        $('.link360').hide();
    }
    refreshSlider();
}

/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {Object} response.product - Product object
 * @param {string} response.product.id - Product ID
 * @param {Object[]} response.product.variationAttributes - Product attributes
 * @param {Object[]} response.product.images - Product images
 * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
 *     attributes have been selected.  Used partially to
 *     determine whether the Add to Cart button can be enabled
 * @param {jQuery} $productContainer - DOM element for a given product.
 */
function handleVariantResponse(response, $productContainer) {
    var isChoiceOfBonusProducts =
        $productContainer.parents('.choose-bonus-product-dialog').length > 0;
    var isVaraint;
    if (response.product.variationAttributes) {
        updateAttrs(response.product.variationAttributes, $productContainer, response.resources);
        isVaraint = response.product.productType === 'variant';
        if (isChoiceOfBonusProducts && isVaraint) {
            $productContainer.parent('.bonus-product-item')
                .data('pid', response.product.id);

            $productContainer.parent('.bonus-product-item')
                .data('ready-to-order', response.product.readyToOrder);
        }
    }

    // 2024 tracking dataLayer - start
    if(response.product.productType === 'variant') {

        let trackingItem =  {
            item_id: response.product.id,
            item_name: response.product.productName,
            price: response.product.price.sales && response.product.price.sales.value ? response.product.price.sales.value.toFixed(2) : 0,
            item_brand: response.product.brand,
            item_category: response.product.category
        };
        var trackingItems = [];
        trackingItems.push(trackingItem);
        console.log(response.product);
    
        let trackingData = {
            'event': 'view_item',
            'currency': response.product.price.sales.currency,
            'value': trackingItem.price,
            'items': trackingItems
        };
    
        window.dataLayer.push(trackingData);
    
    }
    // 2024 tracking dataLayer - end

    // Klaviyo - start
    if(response.klaviyoEvent && response.klaviyoEvent.event == 'Viewed Product') {
        klaviyo.push(["track", "Viewed Product", response.klaviyoEvent.item]);
    }
    // Klaviyo - end

    // Update primary images
    updateSlider(response.product, $productContainer);

    // Update pricing
    if (!isChoiceOfBonusProducts) {
        var $priceSelector = $('.prices .price', $productContainer).length
            ? $('.prices .price', $productContainer)
            : $('.prices .price');
        $priceSelector.replaceWith(response.product.price.html);
    }

    // Update promotions
    $productContainer.find('.promotions').empty().html(response.product.promotionsHtml);

    updateAvailability(response, $productContainer);

    if (isChoiceOfBonusProducts) {
        var $selectButton = $productContainer.find('.select-bonus-product');
        $selectButton.trigger('bonusproduct:updateSelectButton', {
            product: response.product, $productContainer: $productContainer
        });
    } else {
        // Enable "Add to Cart" button if all required attributes have been selected
        $('button.add-to-cart, button.add-to-cart-global, button.update-cart-product-global').trigger('product:updateAddToCart', {
            product: response.product, $productContainer: $productContainer
        }).trigger('product:statusUpdate', response.product);
    }

    // Update attributes
    $productContainer.find('.main-attributes').empty()
        .html(getAttributesHtml(response.product.attributes));
}

/**
 * @typespec UpdatedQuantity
 * @type Object
 * @property {boolean} selected - Whether the quantity has been selected
 * @property {string} value - The number of products to purchase
 * @property {string} url - Compiled URL that specifies variation attributes, product ID, options,
 *     etc.
 */

/**
 * Updates the quantity DOM elements post Ajax call
 * @param {UpdatedQuantity[]} quantities -
 * @param {UpdatedQuantity[]} quantitystep -
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function updateQuantities(quantities, quantitystep, $productContainer) {
    if ($productContainer.parent('.bonus-product-item').length <= 0) {
        if(getQuantitySelector($productContainer).is('select')) {
            var optionsHtml = quantities.map(function (quantity) {
                var selected = quantity.selected ? ' selected ' : '';
                return '<option value="' + quantity.value + '"  data-url="' + quantity.url + '"' +
                    selected + '>' + quantity.value + '</option>';
            }).join('');
            getQuantitySelector($productContainer).empty().html(optionsHtml);
        } else {
            getQuantitySelector($productContainer).data('url', quantitystep.url);
            getQuantitySelector($productContainer).data('min', quantitystep.minOrderQty);
            getQuantitySelector($productContainer).data('step', quantitystep.stepQuantity);
            getQuantitySelector($productContainer).val(quantitystep.quantitySelected);
        }
    }
}

/**
 * Updates the symbols elements post Ajax call
 * @param {Product} product - Product
 */
function updateSymbols(product) {
    $('.symbol-image').empty();
    if (product.symbolList) {
        for (var i = 0; i < product.symbolList.length; i++) {
            $('.symbol-image').append('<img class="symbol-img" src="' + product.symbolList[i].url + '" alt="' + product.symbolList[i].alt + '" title="' + product.symbolList[i].title + '"></img>');
        }
    }
}

/**
 * Updates the recommended products elements post Ajax call
 * @param {Product} product - Product
 */
 function updateRecommenedProducts(product) {
    $('.reccomendations-list').empty();

    if (product.recommendedProducts) {
        product.recommendedProducts.forEach(function (recommendedProduct) {
            var htmlString = ''
            + '<input class="reccomendations-list__item-checkbox" type="checkbox" id="' + recommendedProduct.pid + '" data-pid="' + recommendedProduct.pid + '" data-name="' + recommendedProduct.productName+ '" />'
            + '<label class="reccomendations-list__item" for="' + recommendedProduct.pid + '">'
            + '<figure class="reccomendations-list__item-image"><img src="' + recommendedProduct.image + '?sw=60" alt="' + recommendedProduct.brandName + ' ' + recommendedProduct.productName + '" /></figure>'
            + '<div class="reccomendations-list__item-content">'
            + '<div><a href="' + recommendedProduct.url +'">' + recommendedProduct.productName + '</a></div>';

            if(recommendedProduct.size) {
                htmlString += '<div class="reccomendations-list__item-size">' + recommendedProduct.size + '</div>';
            }

            htmlString += '<div class="reccomendations-list__item-prices">'
            + '<span class="reccomendations-list__item-price">' + recommendedProduct.salePrice +'</span>';

            if(recommendedProduct.listPrice) {
                htmlString += '<span class="reccomendations-list__item-price reccomendations-list__item-price--old">' + recommendedProduct.listPrice +'</span>';
            }

            htmlString += '</div></div>';

            if(recommendedProduct.listPrice) {
                htmlString += '<div class="reccomendations-list__item-tag">' + recommendedProduct.discountText +'</div>';
            }

            htmlString += '</label>';

            $('.reccomendations-list').append(htmlString);
            $('.reccomendations-title').removeClass('d-none');
        });
    } else {
        $('.reccomendations-title').addClass('d-none');
    }   
}

/**
 * Updates the sale badge and the enddate of the offer post Ajax call
 * @param {Product} product - Product
 */
function updateSalePrice(product) {
    if(product.price.discount != null) {
        if ($('.on-sale').length) {
            $('.on-sale').html(product.price.discountFormatted);
        } else {
            $('.on-sale-wrapper').append('<p class="on-sale h7 white">' + product.price.discountFormatted +'</p>');
        }
    } else {
        $('.on-sale').remove();
    }

    if(product.price.saleOnlineTo != null || product.productStatus == 'Rea'|| product.price.longLastingSale) {
        if ($('.priceValidUntil').length) {
            if(product.productStatus == 'Rea' || product.price.longLastingSale) {
                $('.priceValidUntil > span').html(product.price.resources.productDiscontinued);
            } else {
                $('.priceValidUntil > span').html(product.price.saleOnlineToFormatted);
            }
        } else {
            if(product.productStatus == 'Rea' || product.price.longLastingSale) {
                $('.on-sale-wrapper').append('<div class="priceValidUntil"><span><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-clock" viewBox="0 0 16 16"><path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"/><path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z"/></svg> ' + product.price.resources.productDiscontinued + '</span></div>');
            } else {
                $('.on-sale-wrapper').append('<div class="priceValidUntil"><span><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-clock" viewBox="0 0 16 16"><path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"/><path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z"/></svg> ' + product.price.saleOnlineToFormatted + '</span></div>');
            }
            $('.cc-prices').find('.priceValidUntil').addClass('text-center');
        }
    } else {
        $('.priceValidUntil').remove();
    }
}

/**
 * Updates the details elements post Ajax call
 * @param {Product} product - Product
 */
function updateDetails(product) {
    if (product.id) {
        $('.product-id-description').removeClass('d-none');
        $('.product-id-description').find('.text-right').text(product.id);
    } else { 
        $('.product-id-description').addClass('d-none');
    }
    if (product.productMaterial) {
        $('.product-material-description').removeClass('d-none');
        $('.product-material-description').find('.text-right').text(product.productMaterial);
    } else { 
        $('.product-material-description').addClass('d-none');
    }
    if (product.guarantee) {
        $('.product-guarantee-description').removeClass('d-none');
        $('.product-guarantee-description').find('.text-right').text(product.guarantee);
    } else { 
        $('.product-guarantee-description').addClass('d-none');
    }
    if (product.weight) {
        $('.product-weight-description').removeClass('d-none');
        $('.product-weight-description').find('.text-right').text(product.weight);
    } else { 
        $('.product-weight-description').addClass('d-none');
    }
    if (product.length) {
        $('.product-length-description').removeClass('d-none');
        $('.product-length-description').find('.text-right').text(product.length);
    } else { 
        $('.product-length-description').addClass('d-none');
    }
    if (product.width) {
        $('.product-width-description').removeClass('d-none');
        $('.product-width-description').find('.text-right').text(product.width);
    } else { 
        $('.product-width-description').addClass('d-none');
    }
    if (product.height) {
        $('.product-height-description').removeClass('d-none');
        $('.product-height-description').find('.text-right').text(product.height);
    } else { 
        $('.product-height-description').addClass('d-none');
    }
    if (product.weaving) {
        $('.product-weaving-description').removeClass('d-none');
        $('.product-weaving-description').find('.text-right').text(product.weaving);
    } else { 
        $('.product-weaving-description').addClass('d-none');
    }
    if (product.threadCount) {
        $('.product-threadCount-description').removeClass('d-none');
        $('.product-threadCount-description').find('.text-right').text(product.threadCount);
    } else { 
        $('.product-threadCount-description').addClass('d-none');
    }
    if (product.gsm) {
        $('.product-gsm-description').removeClass('d-none');
        $('.product-gsm-description').find('.text-right').text(product.gsm);
    } else { 
        $('.product-gsm-description').addClass('d-none');
    }
    if (product.shape) {
        $('.product-shape-description').removeClass('d-none');
        $('.product-shape-description').find('.text-right').text(product.shape);
    } else { 
        $('.product-shape-description').addClass('d-none');
    }
    if (product.coating) {
        $('.product-coating-description').removeClass('d-none');
        $('.product-coating-description').find('.text-right').text(product.coating);
    } else { 
        $('.product-coating-description').addClass('d-none');
    }
    if (product.patterns) {
        $('.product-patterns-description').removeClass('d-none');
        $('.product-patterns-description').find('.text-right').text(product.patterns);
    } else { 
        $('.product-patterns-description').addClass('d-none');
    }
    if (product.burntime) {
        $('.product-burntime-description').removeClass('d-none');
        $('.product-burntime-description').find('.text-right').text(product.burntime);
    } else { 
        $('.product-burntime-description').addClass('d-none');
    }
    if (product.fscType) {
        $('.product-fscType-description').removeClass('d-none');
        $('.product-fscType-description').find('.text-right').text(product.fscType);
    } else { 
        $('.product-fscType-description').addClass('d-none');
    }
    if (product.fscMaterial) {
        $('.product-fscMaterial-description').removeClass('d-none');
        $('.product-fscMaterial-description').find('.text-right').text(product.fscMaterial);
    } else { 
        $('.product-fscMaterial-description').addClass('d-none');
    }
    if (product.watt) {
        $('.product-watt-description').removeClass('d-none');
        $('.product-watt-description').find('.text-right').text(product.watt);
    } else { 
        $('.product-watt-description').addClass('d-none');
    }
    if (product.volt) {
        $('.product-volt-description').removeClass('d-none');
        $('.product-volt-description').find('.text-right').text(product.volt);
    } else { 
        $('.product-volt-description').addClass('d-none');
    }
    if (product.lowestDecibels) {
        $('.product-lowestDecibels-description').removeClass('d-none');
        $('.product-lowestDecibels-description').find('.text-right').text(product.lowestDecibels);
    } else { 
        $('.product-lowestDecibels-description').addClass('d-none');
    }
    if (product.averageDecibels) {
        $('.product-averageDecibels-description').removeClass('d-none');
        $('.product-averageDecibels-description').find('.text-right').text(product.averageDecibels);
    } else { 
        $('.product-averageDecibels-description').addClass('d-none');
    }
    if (product.highestDecibels) {
        $('.product-highestDecibels-description').removeClass('d-none');
        $('.product-highestDecibels-description').find('.text-right').text(product.highestDecibels);
    } else { 
        $('.product-highestDecibels-description').addClass('d-none');
    }
    if (product.minTemperature) {
        $('.product-minTemperature-description').removeClass('d-none');
        $('.product-minTemperature-description').find('.text-right').text(product.minTemperature);
    } else { 
        $('.product-minTemperature-description').addClass('d-none');
    }
    if (product.maxTemperature) {
        $('.product-maxTemperature-description').removeClass('d-none');
        $('.product-maxTemperature-description').find('.text-right').text(product.maxTemperature);
    } else { 
        $('.product-maxTemperature-description').addClass('d-none');
    }
    if (product.revolutionsPerMinute) {
        $('.product-revolutionsPerMinute-description').removeClass('d-none');
        $('.product-revolutionsPerMinute-description').find('.text-right').text(product.revolutionsPerMinute);
    } else { 
        $('.product-revolutionsPerMinute-description').addClass('d-none');
    }
    if (product.cleanAirDeliveryRate) {
        $('.product-cleanAirDeliveryRate-description').removeClass('d-none');
        $('.product-cleanAirDeliveryRate-description').find('.text-right').text(product.cleanAirDeliveryRate);
    } else { 
        $('.product-cleanAirDeliveryRate-description').addClass('d-none');
    }
    if (product.ampere) {
        $('.product-ampere-description').removeClass('d-none');
        $('.product-ampere-description').find('.text-right').text(product.ampere);
    } else { 
        $('.product-ampere-description').addClass('d-none');
    }
    if (product.hertz) {
        $('.product-hertz-description').removeClass('d-none');
        $('.product-hertz-description').find('.text-right').text(product.hertz);
    } else { 
        $('.product-hertz-description').addClass('d-none');
    }
    if (product.btu) {
        $('.product-btu-description').removeClass('d-none');
        $('.product-btu-description').find('.text-right').text(product.btu);
    } else { 
        $('.product-btu-description').addClass('d-none');
    }
    if(product.shortDescription || product.longDescription) {
        var productText = '';

        if(product.shortDescription) {
            $('.text-description').html(product.shortDescription);
            if(!product.customDescription) {
                productText += '<p>' + product.shortDescription + '</p>';
            }
        }
        if(product.longDescription) {
            productText += '<p>' + product.longDescription + '</p>';
        }
        if(product.salesforcelongtextKLD) {
            productText = '<p>' + product.salesforcelongtextKLD + '</p>';
        }

        $('.product-text-element').html(productText);
    }
    if (product.variationAttributes[0].attributeId === 'color') {
        $('.product-color-description').removeClass('d-none');
        $('.product-color-description').find('.text-right').text(product.variationAttributes[0].displayValue);
    } else if (product.variationAttributes[1].attributeId === 'color') {
        $('.product-color-description').removeClass('d-none');
        $('.product-color-description').find('.text-right').text(product.variationAttributes[1].displayValue);
    } else $('.product-color-description').addClass('d-none');

    if (product.gpsrBrandName) {
        $('.product-safety-description').removeClass('d-none');
        $('.product-manufacturer-brandname').removeClass('d-none');
        $('.product-manufacturer-brandname').find('.text-right a').text(product.gpsrBrandName);
    } else {
        $('.product-manufacturer-brandname').addClass('d-none');
    }

    if (product.gpsrElectronicAdress) {
        $('.product-manufacturer-brandname').removeClass('d-none');
        $('.product-manufacturer-brandname').find('.text-right a')
            .text(product.gpsrBrandName)
            .attr('href', product.gpsrElectronicAdress);
    } else {
        $('.product-manufacturer-brandname').find('.text-right a')
        .attr('href', '#');
    }
    
    if (product.gpsrManufactorAdress) {
        $('.product-manufacturer-adress').removeClass('d-none');
        $('.product-manufacturer-adress').find('.text-right').text(product.gpsrManufactorAdress);
    } else {
        $('.product-manufacturer-adress').addClass('d-none');
    }

    if (product.gpsrPostalAdress) {
        $('.product-manufacturer-postal').removeClass('d-none');
        $('.product-manufacturer-postal').find('.text-right').text(product.gpsrPostalAdress);
    } else {
        $('.product-manufacturer-postal').addClass('d-none');
    }

    if (product.userManualReady === 'Yes' && !isNaN(product.id)) {
        $('.product-saftey-instruction').removeClass('d-none');
        $('.product-saftey-instruction')
            .find('.text-right a')
            .attr('href', `https://productfiles.fh-group.dk/usermanual/${product.id}`);
    } else {
        $('.product-saftey-instruction').addClass('d-none');
    }
    if (product.expiredatefh) {
        $('.symbol-swan').removeClass('d-none');
    } else {
        $('.symbol-swan').addClass('d-none');
    }
    
    if (product.oekoTexExpireDate) {
        $('.symbol-oekotex').removeClass('d-none');
    } else {
        $('.symbol-oekotex').addClass('d-none');
    }

    // Svanemærket-symbol
    if (product.swansymbol) {
        $('.symbol-swan img').attr('src', '/on/demandware.static/-/Sites-FH_master_catalog/default/dwbdfe546c/images/Symboler/' + product.swansymbol);
    } else {
        $('.symbol-swan img').attr('src', '/on/demandware.static/Sites-KLD-Site/-/default/dw03aeed87/images/logo-swan.png');
    }

    // Oeko-Tex-symbol
    if (product.oekoTexSymbol && product.oekoTexExpireDate) {
        $('.symbol-oekotex img').attr('src', product.oekoTexSymbol);
    } else {
        $('.symbol-oekotex img').attr('src', '/on/demandware.static/Sites-KLD-Site/-/default/dw03aeed87/images/logo-oekotex.png');
    }


}

/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 */
function attributeSelect(selectedValueUrl, $productContainer) {
    if (selectedValueUrl) {
        $('body').trigger('product:beforeAttributeSelect',
            { url: selectedValueUrl, container: $productContainer });

        $.ajax({
            url: selectedValueUrl,
            method: 'GET',
            success: function (data) {
                handleVariantResponse(data, $productContainer);
                updateOptions(data.product.optionsHtml, $productContainer);
                updateQuantities(data.product.quantities, data.product.quantitystep, $productContainer);
                updateSymbols(data.product);
                updateRecommenedProducts(data.product);
                updateDetails(data.product);
                updateSalePrice(data.product);
                $('body').trigger('product:afterAttributeSelect',
                    { data: data, container: $productContainer });
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    }
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @return {string} - The provided URL to use when adding a product to the cart
 */
function getAddToCartUrl() {
    return $('.add-to-cart-url').val();
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.choice-of-bonus-product');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @param {Object} data - data object used to fill in dynamic portions of the html
 */
function chooseBonusProducts(data) {
    $('.modal-body').spinner().start();

    if ($('#chooseBonusProductModal').length !== 0) {
        $('#chooseBonusProductModal').remove();
    }
    var bonusUrl;
    if (data.bonusChoiceRuleBased) {
        bonusUrl = data.showProductsUrlRuleBased;
    } else {
        bonusUrl = data.showProductsUrlListBased;
    }

    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="chooseBonusProductModal" tabindex="-1" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog choose-bonus-product-dialog" '
        + 'data-total-qty="' + data.maxBonusItems + '"'
        + 'data-UUID="' + data.uuid + '"'
        + 'data-pliUUID="' + data.pliUUID + '"'
        + 'data-addToCartUrl="' + data.addToCartUrl + '"'
        + 'data-pageStart="0"'
        + 'data-pageSize="' + data.pageSize + '"'
        + 'data-moreURL="' + data.showProductsUrlRuleBased + '"'
        + 'data-bonusChoiceRuleBased="' + data.bonusChoiceRuleBased + '">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <span class="">' + data.labels.selectprods + '</span>'
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '        <span aria-hidden="true">&times;</span>'
        + '        <span class="sr-only"> </span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
    $('.modal-body').spinner().start();

    $.ajax({
        url: bonusUrl,
        method: 'GET',
        dataType: 'json',
        success: function (response) {
            var parsedHtml = parseHtml(response.renderedTemplate);
            $('#chooseBonusProductModal .modal-body').empty();
            $('#chooseBonusProductModal .enter-message').text(response.enterDialogMessage);
            $('#chooseBonusProductModal .modal-header .close .sr-only').text(response.closeButtonText);
            $('#chooseBonusProductModal .modal-body').html(parsedHtml.body);
            $('#chooseBonusProductModal .modal-footer').html(parsedHtml.footer);
            $('#chooseBonusProductModal').modal('show');
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
function handlePostCartAdd(response) {
    $('.minicart').trigger('count:update', response);
    var messageType = response.error ? 'alert-danger' : 'alert-success';
    // show add to cart toast
    if (response.newBonusDiscountLineItem
        && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
        chooseBonusProducts(response.newBonusDiscountLineItem);
    } else {
        if ($('.add-to-cart-messages').length === 0) {
            $('body').append(
                '<div class="add-to-cart-messages"></div>'
            );
        }

        $('.add-to-cart-messages').append(
            '<div class="alert ' + messageType + ' add-to-basket-alert text-center" role="alert">'
            + response.message
            + '</div>'
        );

        setTimeout(function () {
            $('.add-to-basket-alert').remove();
        }, 5000);
    }
}

/**
 * Retrieves the bundle product item ID's for the Controller to replace bundle master product
 * items with their selected variants
 *
 * @return {string[]} - List of selected bundle product item ID's
 */
function getChildProducts() {
    var childProducts = [];
    $('.bundle-item').each(function () {
        childProducts.push({
            pid: $(this).find('.product-id').text(),
            quantity: parseInt($(this).find('label.quantity').data('quantity'), 10)
        });
    });

    return childProducts.length ? JSON.stringify(childProducts) : [];
}

/**
 * Retrieve product options
 *
 * @param {jQuery} $productContainer - DOM element for current product
 * @return {string} - Product options and their selected values
 */
function getOptions($productContainer) {
    var options = $productContainer
        .find('.product-option')
        .map(function () {
            var $elOption = $(this).find('.options-select');
            var urlValue = $elOption.val();
            var selectedValueId = $elOption.find('option[value="' + urlValue + '"]')
                .data('value-id');
            return {
                optionId: $(this).data('option-id'),
                selectedValueId: selectedValueId
            };
        }).toArray();

    return JSON.stringify(options);
}

/**
 * Makes a call to the server to report the event of adding an item to the cart
 *
 * @param {string | boolean} url - a string representing the end point to hit so that the event can be recorded, or false
 */
function miniCartReportingUrl(url) {
    if (url) {
        $.ajax({
            url: url,
            method: 'GET',
            success: function () {
                // reporting urls hit on the server
            },
            error: function () {
                // no reporting urls hit on the server
            }
        });
    }
}

module.exports = {
    attributeSelect: attributeSelect,
    loadSlider: loadSlider,
    methods: {
        editBonusProducts: function (data) {
            chooseBonusProducts(data);
        }
    },

    focusChooseBonusProductModal: function () {
        $('body').on('shown.bs.modal', '#chooseBonusProductModal', function () {
            $('#chooseBonusProductModal').siblings().attr('aria-hidden', 'true');
            $('#chooseBonusProductModal .close').focus();
        });
    },

    onClosingChooseBonusProductModal: function () {
        $('body').on('hidden.bs.modal', '#chooseBonusProductModal', function () {
            $('#chooseBonusProductModal').siblings().attr('aria-hidden', 'false');
        });
    },

    trapChooseBonusProductModalFocus: function () {
        $('body').on('keydown', '#chooseBonusProductModal', function (e) {
            var focusParams = {
                event: e,
                containerSelector: '#chooseBonusProductModal',
                firstElementSelector: '.close',
                lastElementSelector: '.add-bonus-products'
            };
            focusHelper.setTabNextFocus(focusParams);
        });
    },

    colorAttribute: function () {
        $(document).on('click', '[data-attr="color"] button', function (e) {
            e.preventDefault();

            if ($(this).attr('disabled')) {
                return;
            }
            $('.product-detail:not(.product-quickview) .color-attribute').prop('disabled', false);
            $('.product-detail:not(.product-quickview) .primary-images+div .attributes .color-attribute').prop('disabled', false);
            $('.product-quickview .color-attribute').prop('disabled', false);
            $('.product-quickview .primary-images+div .attributes .color-attribute').prop('disabled', false);
            $(this).prop('disabled', true);
            var $productContainer = $(this).closest('.set-item');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.product-detail');
            }

            $('.selectpicker').find('option').each(function(){
                if(!$(this).hasClass('js-label-select-size')) {
                    $(this).attr('data-content', $(this).attr('data-value-select'));
                    $('.selectpicker').selectpicker('refresh');
                }
            });

            attributeSelect($(this).attr('data-url'), $productContainer);

            $('.js-label-color').empty().text($(this).data('color'));
        });
    },

    selectAttribute: function () {
        $(document).on('change', 'select[class*="select-"], .options-select', function (e) {
            e.preventDefault();

            var $productContainer = $(this).closest('.set-item');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.product-detail');
            }

            $('.selectpicker').find('option:selected').each(function(){
                $(this).attr('data-content', $(this).attr('data-value-select'));
                $('.selectpicker').selectpicker('refresh');
            });

            attributeSelect(e.currentTarget.value, $productContainer);
        });
    },

    availability: function () {
        $(document).on('change', '.quantity-select', function (e) {
            e.preventDefault();
            var attributeUrl;
            if($(e.currentTarget).is('select')) {
                attributeUrl = $(e.currentTarget).find('option:selected').data('url');
            } else {
                var quantityValue = $(e.currentTarget).val();
                attributeUrl = $(e.currentTarget).data('url')+'&quantity='+quantityValue;
            }

            var $productContainer = $(this).closest('.product-detail');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.modal-content').find('.product-quickview');
            }

            if ($('.bundle-items', $productContainer).length === 0) {
                attributeSelect(attributeUrl,
                    $productContainer);
            }
        });
    },

    addToCart: function () {
        $('body').on('click', 'button.add-to-cart, button.add-to-cart-global', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            var addToCartUrl;
            var pid;
            var pidsObj;
            var setPids;
            var recPids;
            
            $('body').trigger('product:beforeAddToCart', this);

            if ($('.set-items').length && $(this).hasClass('add-to-cart-global')) {
                setPids = [];

                $('.product-detail').each(function () {
                    if (!$(this).hasClass('product-set-detail')) {
                        setPids.push({
                            pid: $(this).find('.product-id').text(),
                            qty: $(this).find('.quantity-select').val(),
                            options: getOptions($(this))
                        });
                    }
                });
                pidsObj = JSON.stringify(setPids);
            }

            pid = getPidValue($(this));

            var $productContainer = $(this).closest('.product-detail');

            var productAnalytics = $(this).closest('.buy-button').find('.analytics.product');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.quick-view-dialog').find('.product-detail');
            }

            addToCartUrl = getAddToCartUrl();

            var analyticsRecProducts = [];
            if ($('.reccomendations').length) {
                recPids = [];
          
                $('.reccomendations-list__item-checkbox').each(function () {
                    if ($(this).is(':checked')) {
                        recPids.push({
                            pid: $(this).data('pid'),
                            qty: 1
                        });

                        analyticsRecProducts.push({
                            pid: $(this).data('pid'),
                            name: $(this).data('name')
                        });
                    }
                });

                recPids.push({
                    pid: pid,
                    qty: getQuantitySelected($(this))
                });
                pidsObj = JSON.stringify(recPids);
            }

            var form = {
                pid: pid,
                pidsObj: pidsObj,
                childProducts: getChildProducts(),
                quantity: getQuantitySelected($(this))
            };

            if (!$('.bundle-item').length) {
                form.options = getOptions($productContainer);
            }

            $(this).trigger('updateAddToCartFormData', form);
            if (addToCartUrl) {
                $.ajax({
                    url: addToCartUrl,
                    method: 'POST',
                    data: form,
                    success: function (data) {
                        handlePostCartAdd(data);
                        $('body').trigger('product:afterAddToCart', data);
                        $.spinner().stop();
                        miniCartReportingUrl(data.reportingURL);
                        productAnalytics.data('price', data.cart.items[data.cart.items.length-1].price.sales.value);
                        pushAnalyticsAddToCart(form, productAnalytics, data.color, analyticsRecProducts);
                        // Klaviyo - start
                        if(data.klaviyoEvent.event == 'Added to Cart') {
                            klaviyo.push(["track", "Added to Cart", data.klaviyoEvent.item]);
                        }
                        // Klaviyo - end
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            }
        });
    },
    selectBonusProduct: function () {
        $(document).on('click', '.select-bonus-product', function () {
            var $choiceOfBonusProduct = $(this).parents('.choice-of-bonus-product');
            var pid = $(this).data('pid');
            var maxPids = $('.choose-bonus-product-dialog').data('total-qty');
            var submittedQty = parseInt($choiceOfBonusProduct.find('.bonus-quantity-select').val(), 10);
            var totalQty = 0;
            $.each($('#chooseBonusProductModal .selected-bonus-products .selected-pid'), function () {
                totalQty += $(this).data('qty');
            });
            totalQty += submittedQty;
            var optionID = $choiceOfBonusProduct.find('.product-option').data('option-id');
            var valueId = $choiceOfBonusProduct.find('.options-select option:selected').data('valueId');
            if (totalQty <= maxPids) {
                var selectedBonusProductHtml = ''
                + '<div class="selected-pid row" '
                + 'data-pid="' + pid + '"'
                + 'data-qty="' + submittedQty + '"'
                + 'data-optionID="' + (optionID || '') + '"'
                + 'data-option-selected-value="' + (valueId || '') + '"'
                + '>'
                + '<div class="col-sm-11 col-9 bonus-product-name" >'
                + $choiceOfBonusProduct.find('.product-name').html()
                + '</div>'
                + '<div class="col-1"><i class="fa fa-times" aria-hidden="true"></i></div>'
                + '</div>'
                ;
                $('#chooseBonusProductModal .selected-bonus-products').append(selectedBonusProductHtml);
                $('.pre-cart-products').html(totalQty);
                $('.selected-bonus-products .bonus-summary').removeClass('alert-danger');
            } else {
                $('.selected-bonus-products .bonus-summary').addClass('alert-danger');
            }
        });
    },
    removeBonusProduct: function () {
        $(document).on('click', '.selected-pid', function () {
            $(this).remove();
            var $selected = $('#chooseBonusProductModal .selected-bonus-products .selected-pid');
            var count = 0;
            if ($selected.length) {
                $selected.each(function () {
                    count += parseInt($(this).data('qty'), 10);
                });
            }

            $('.pre-cart-products').html(count);
            $('.selected-bonus-products .bonus-summary').removeClass('alert-danger');
        });
    },
    enableBonusProductSelection: function () {
        $('body').on('bonusproduct:updateSelectButton', function (e, response) {
            $('button.select-bonus-product', response.$productContainer).attr('disabled',
                (!response.product.readyToOrder || !response.product.available));
            var pid = response.product.id;
            $('button.select-bonus-product', response.$productContainer).data('pid', pid);
        });
    },
    showMoreBonusProducts: function () {
        $(document).on('click', '.show-more-bonus-products', function () {
            var url = $(this).data('url');
            $('.modal-content').spinner().start();
            $.ajax({
                url: url,
                method: 'GET',
                success: function (html) {
                    var parsedHtml = parseHtml(html);
                    $('.modal-body').append(parsedHtml.body);
                    $('.show-more-bonus-products:first').remove();
                    $('.modal-content').spinner().stop();
                },
                error: function () {
                    $('.modal-content').spinner().stop();
                }
            });
        });
    },
    addBonusProductsToCart: function () {
        $(document).on('click', '.add-bonus-products', function () {
            var $readyToOrderBonusProducts = $('.choose-bonus-product-dialog .selected-pid');
            var queryString = '?pids=';
            var url = $('.choose-bonus-product-dialog').data('addtocarturl');
            var pidsObject = {
                bonusProducts: []
            };

            $.each($readyToOrderBonusProducts, function () {
                var qtyOption =
                    parseInt($(this)
                        .data('qty'), 10);

                var option = null;
                if (qtyOption > 0) {
                    if ($(this).data('optionid') && $(this).data('option-selected-value')) {
                        option = {};
                        option.optionId = $(this).data('optionid');
                        option.productId = $(this).data('pid');
                        option.selectedValueId = $(this).data('option-selected-value');
                    }
                    pidsObject.bonusProducts.push({
                        pid: $(this).data('pid'),
                        qty: qtyOption,
                        options: [option]
                    });
                    pidsObject.totalQty = parseInt($('.pre-cart-products').html(), 10);
                }
            });
            queryString += JSON.stringify(pidsObject);
            queryString = queryString + '&uuid=' + $('.choose-bonus-product-dialog').data('uuid');
            queryString = queryString + '&pliuuid=' + $('.choose-bonus-product-dialog').data('pliuuid');
            $.spinner().start();
            $.ajax({
                url: url + queryString,
                method: 'POST',
                success: function (data) {
                    $.spinner().stop();
                    if (data.error) {
                        $('#chooseBonusProductModal').modal('hide');
                        if ($('.add-to-cart-messages').length === 0) {
                            $('body').append('<div class="add-to-cart-messages"></div>');
                        }
                        $('.add-to-cart-messages').append(
                            '<div class="alert alert-danger add-to-basket-alert text-center"'
                            + ' role="alert">'
                            + data.errorMessage + '</div>'
                        );
                        setTimeout(function () {
                            $('.add-to-basket-alert').remove();
                        }, 3000);
                    } else {
                        $('.configure-bonus-product-attributes').html(data);
                        $('.bonus-products-step2').removeClass('hidden-xl-down');
                        $('#chooseBonusProductModal').modal('hide');

                        if ($('.add-to-cart-messages').length === 0) {
                            $('body').append('<div class="add-to-cart-messages"></div>');
                        }
                        $('.minicart-quantity').html(data.totalQty);
                        $('.add-to-cart-messages').append(
                            '<div class="alert alert-success add-to-basket-alert text-center"'
                            + ' role="alert">'
                            + data.msgSuccess + '</div>'
                        );
                        setTimeout(function () {
                            $('.add-to-basket-alert').remove();
                            if ($('.cart-page').length) {
                                location.reload();
                            }
                        }, 1500);
                    }
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },
    outOfStockMessage: function (message) {

        $('.selectpicker').find('option:selected').each(function() {
            if(!$(this).hasClass('js-label-select-size')) {
                $(this).attr('data-content', $(this).attr('data-value-select') + '<span class="custom-select-text sold-out">' + message + '<span>');
                $('.selectpicker').selectpicker('refresh');
            }
        });


    },
    initSlider: function() {
        loadSlider();
    },

    getPidValue: getPidValue,
    getQuantitySelected: getQuantitySelected,
    miniCartReportingUrl: miniCartReportingUrl
};

/*
$(document).ready(function () {
    var labelSelectSize = $(window).width() < 768 ? $($('.select-size')[1]).find(':selected').hasClass('js-label-select-size') : $($('.select-size')[0]).find(':selected').hasClass('js-label-select-size');
    if ($('.color-attribute.selected').length > 0 && !labelSelectSize) {
        var $productContainer = $(window).width() < 768 ? $($('.product-detail')[1]) : $($('.product-detail')[0]);
        attributeSelect($('.color-attribute.selected').data('url'), $productContainer);
    }
});
*/

function pushAnalyticsAddToCart (info, productBase, color, recProducts) {

    var prodPid = info.pid;
    var prodName = productBase.data('name');
    var prodPrice = productBase.data('price');
    var prodBrand = productBase.data('brand');
    var prodColor = color;
    var prodCategory = productBase.data('category');
    var prodQuantity = info.quantity;
    var prodCurrency = productBase.data('currency');
    var item = {
        name: prodName ? prodName : '',
        id: prodPid ? prodPid : '',
        price: prodPrice ? prodPrice : '',
        brand: prodBrand ? prodBrand : '',
        category: prodCategory ? prodCategory : '',
        variant: prodColor ? prodColor : '',
        quantity: prodQuantity ? prodQuantity : '1'
    }

    var items = [];
    items.push(item);

    if(recProducts) {
        recProducts.forEach(function (recProduct) {
            items.push({name: recProduct.name, id: recProduct.pid, category: 'recommended products', quantity: '1'});
        });
    }

    let pushObject = {
        'event': 'addToCart',
        'ecommerce': {
            'currencyCode': prodCurrency,
            'add': {
                'products': items
            }
        }
    };

    dataLayer.push(pushObject);

    // 2024 tracking dataLayer - start
    let trackingItem =  {
        item_id: prodPid ? prodPid : '',
        item_name: prodName ? prodName : '',
        price: prodPrice ? prodPrice : 0,
        item_brand: prodBrand ? prodBrand : '',
        item_category: prodCategory ? prodCategory : '',
        quantity: prodQuantity ? prodQuantity : 1
    };
    var trackingItems = [];
    trackingItems.push(trackingItem);

    let trackingData = {
        'event': 'add_to_cart',
        'currency': prodCurrency,
        'value': trackingItem.price * trackingItem.quantity,
        'items': trackingItems
    };

    window.dataLayer.push(trackingData);
    // 2024 tracking dataLayer - end
}

function handleQuantitySteps() {
    $('body').on('click', '.quantity-subtract', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var $input = $(this).next();
        var currentValue = parseInt($input.val());
        var minValue = parseInt($input.data('min'));
        var stepValue = parseInt($input.data('step'));
        if((currentValue - stepValue) >= minValue) {
            $input.val(currentValue - stepValue).trigger('change');
        }
    });
    $('body').on('click', '.quantity-add', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var $input = $(this).prev();
        var currentValue = parseInt($input.val());
        var stepValue = parseInt($input.data('step'));
        $input.val(currentValue + stepValue).trigger('change');
    });
}
handleQuantitySteps();

function loadSlider() {
    if($('#main-slider').length > 0) {
        window.mainSlide = new Splide( '#main-slider', {
            type       : 'loop',
            pagination : false,
            arrows     : true,
            arrowPath: 'm17.5 5.999-.707.707 5.293 5.293H1v1h21.086l-5.294 5.295.707.707L24 12.499l-6.5-6.5z',
            drag       : 'free',
            snap       : true,
            gap        : 10,
            dragMinThreshold: {
                mouse: 4,
                touch: 10,
            },
            video: {
                loop         : false,
                mute         : false,
                autoplay     : false,
                preload      : true,
                heightRatio  : 1.5625,
                cover        : true,
            },
            breakpoints: {
                1024: {
                perPage: 1,
                padding: { left: '0rem', right: '3rem' },
                pagination : true,
                arrows : false,
                },
            }
        });

        window.thumbnailSlide = new Splide( '#thumbnail-slider', {
            direction       : 'ttb',
            height          : '1rem',
            autoHeight      : true,
            rewind          : true,
            isNavigation    : true,
            gap             : 5,
            focus           : 'center',
            pagination      : false,
            arrows     : true,
            arrowPath: 'm17.5 5.999-.707.707 5.293 5.293H1v1h21.086l-5.294 5.295.707.707L24 12.499l-6.5-6.5z',
            dragMinThreshold: {
                mouse: 4,
                touch: 10,
            }
        });

        window.mainSlide.sync(window.thumbnailSlide);
        window.mainSlide.mount(window.splide.Extensions);
        window.thumbnailSlide.mount();
    }
}

function refreshSlider() {
    if(window.mainSlide) {
        window.mainSlide.destroy();
        window.thumbnailSlide.destroy();
    }
    loadSlider();
}


// WEBPACK FOOTER //
// ./cartridges/app_fh/cartridge/client/default/js/product/base.js